<template>
  <el-card>
    <lang-form @confirm="handleSubmit" />
  </el-card>
</template>

<script>
import LangForm from "@/components/lang-form/LangForm";
import {request} from "@/config/request";
export default {
  name: "LangAdd",
  components: {LangForm},
  methods: {
    async handleSubmit(data) {
      try {
        await request(this.$api.areaLanguageSet.add, data);
        this.$message.success("操作成功");
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
